/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Notes_EditInputs */

const en_recipe_notes_edit = /** @type {(inputs: Recipe_Notes_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit notes`)
};

const de_recipe_notes_edit = /** @type {(inputs: Recipe_Notes_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit notes" |
*
* @param {Recipe_Notes_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_notes_edit = /** @type {((inputs?: Recipe_Notes_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Notes_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_notes_edit(inputs)
	return en_recipe_notes_edit(inputs)
});